<main class="home-page">
    <section class="hero-panel" aria-labelledby="home-title">
        <div class="hero-content">
            <p class="eyebrow">Maintenance Management</p>
            <h1 id="home-title">Keep work<br /><span>moving.</span></h1>
            <p class="hero-summary">
                Plan, submit, and track maintenance work across Hanwha Philly Shipyard.
            </p>
            <a class="hero-action" routerLink="/new-request">
                Submit a request <span aria-hidden="true">&#8594;</span>
            </a>
        </div>
        <div class="hero-caption" aria-label="Hanwha Philly Shipyard">
            <span class="caption-rule" aria-hidden="true"></span>
            Hanwha Philly Shipyard
        </div>
    </section>

    <section class="welcome-section" aria-labelledby="welcome-title">
        <div class="section-heading">
            <p class="eyebrow">One workspace</p>
            <h2 id="welcome-title">Maintenance, made visible.</h2>
        </div>
        <div class="welcome-copy">
            <p>
                Use a single place to report equipment issues, keep active work in view,
                and preserve a reliable record of completed maintenance.
            </p>
            <p>
                Start with the task in front of you, then follow each request through to
                completion.
            </p>
        </div>
    </section>

    <section class="workspace-section" aria-labelledby="workspace-title">
        <div class="section-heading">
            <p class="eyebrow">Workspace</p>
            <h2 id="workspace-title">Choose your next action.</h2>
            <p>Everything needed to keep maintenance work on course.</p>
        </div>

        <div class="workspace-grid">
            <a class="workspace-card" routerLink="/new-request">
                <span class="card-index">01 / REPORT</span>
                <span class="card-title">New request</span>
                <span class="card-detail">Log an equipment or facility issue.</span>
                <span class="card-arrow" aria-hidden="true">&#8594;</span>
            </a>
            <a class="workspace-card" routerLink="/in-process">
                <span class="card-index">02 / TRACK</span>
                <span class="card-title">In-process work</span>
                <span class="card-detail">Review requests currently under way.</span>
                <span class="card-arrow" aria-hidden="true">&#8594;</span>
            </a>
            <a class="workspace-card" routerLink="/archived-requests">
                <span class="card-index">03 / REVIEW</span>
                <span class="card-title">Archived requests</span>
                <span class="card-detail">Search completed maintenance records.</span>
                <span class="card-arrow" aria-hidden="true">&#8594;</span>
            </a>
            <a class="workspace-card" href="#workspace-title">
                <span class="card-index">04 / OVERVIEW</span>
                <span class="card-title">Maintenance workspace</span>
                <span class="card-detail">Find the right place to begin your work.</span>
                <span class="card-arrow" aria-hidden="true">&#8594;</span>
            </a>
        </div>
    </section>
</main>